<template>
  <div class="md-layout">
    <md-dialog :md-active.sync="showAddTravellerDialog">
      <md-dialog-title>Add a Traveller</md-dialog-title>
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(addTraveller)">
          <div class="md-layout">
            <div class="md-layout-item md-size-100">
              <h6>Traveller</h6>
              <customer-dropdown v-model="traveller.user_id" />
            </div>
          </div>

          <md-dialog-actions>
            <md-button class="md-primary md-dense" @click="cancel"
              >Cancel</md-button
            >
            <md-button type="submit" class="md-primary md-dense">Add</md-button>
          </md-dialog-actions>
        </form>
      </ValidationObserver>
    </md-dialog>
  </div>
</template>

<script>
import bookingApi from "@/services/api/booking";
import CustomerDropdown from "@/components/Handi/Users/CustomerDropdown.vue";

export default {
  name: "BookingAddTraveller",

  props: ["showAddTravellerDialog", "booking"],

  data() {
    return {
      traveller: {
        user_id: null
      },
      customers: []
    };
  },

  components: {
    CustomerDropdown
  },

  methods: {
    cancel() {
      this.$emit("cancel");
    },

    addTraveller() {
      let data = {
        booking: this.booking,
        traveller: this.traveller
      };

      bookingApi.addTraveller(data).then(response => {
        this.$emit("new-traveller", response.data);
      });
    }
  },

  watch: {},

  mounted() {}
};
</script>
